export const PUBLISH_OR_UNPUBLISH_CONTENT = "PUBLISH_OR_UNPUBLISH_CONTENT";
export const RESET_PUBLISH_STORE = "RESET_PUBLISH_STORE";